"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DawnCity = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var SpaceName_1 = require("../../SpaceName");
var SpaceType_1 = require("../../SpaceType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var DawnCity = (function (_super) {
    __extends(DawnCity, _super);
    function DawnCity() {
        return _super.call(this, {
            name: CardName_1.CardName.DAWN_CITY,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.SPACE],
            cost: 15,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 4); }),
            metadata: {
                cardNumber: '220',
                description: 'Requires 4 Science tags. Decrease your energy production 1 step. Increase your titanium production 1 step. Place a City tile on the RESERVED AREA.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).br;
                        pb.plus().titanium(1);
                    }).nbsp.city().asterix();
                }),
                victoryPoints: 3,
            },
        }) || this;
    }
    ;
    DawnCity.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) && player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    DawnCity.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.game.addCityTile(player, SpaceName_1.SpaceName.DAWN_CITY, SpaceType_1.SpaceType.COLONY);
        return undefined;
    };
    DawnCity.prototype.getVictoryPoints = function () {
        return 3;
    };
    return DawnCity;
}(Card_1.Card));
exports.DawnCity = DawnCity;
//# sourceMappingURL=DawnCity.js.map